/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Try_MobileInputs */

const en_dialog_try_mobile = /** @type {(inputs: Dialog_Try_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try our mobile app`)
};

const es_dialog_try_mobile = /** @type {(inputs: Dialog_Try_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba nuestra app móvil`)
};

/**
* | output |
* | --- |
* | "Try our mobile app" |
*
* @param {Dialog_Try_MobileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_try_mobile = /** @type {((inputs?: Dialog_Try_MobileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Try_MobileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_try_mobile(inputs)
	return en_dialog_try_mobile(inputs)
});